import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-32b279ed"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tenant-user-container"
};
const _hoisted_2 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "20px"
  }
}, null, -1));
const _hoisted_4 = {
  style: {
    "margin-left": "20px"
  }
};
const _hoisted_5 = {
  class: "pagination-box"
};
import { onMounted, ref } from 'vue';
import { Search, Refresh } from '@element-plus/icons-vue';
import usePagination from '@/hooks/usePagination';
import { indexMethod } from '@/utils/indexMethod';
import TenantUser from './components/TenantUser';
import { getRoleList } from '@/api/role';
import { formSchemas } from './config';
import TenantSelect from '@/components/TenantSelect';
import { findHisLoginUserPage } from '@/api/tenant';
export default {
  __name: 'index',
  setup(__props) {
    const formSchemasRef = ref(formSchemas);
    const {
      currentPage,
      total,
      pageSize,
      setCurrentPage,
      setTotal
    } = usePagination();
    const tableData = ref([]);
    const loading = ref(false);
    const tenantId = ref('');
    const keyword = ref('');
    const _getUserPageListByTenantId = async () => {
      loading.value = true;
      const res = await findHisLoginUserPage({
        tenantId: tenantId.value,
        currentPage: currentPage.value,
        pageSize: pageSize.value,
        keyword: keyword.value
      });
      tableData.value = res.records;
      setTotal(res.total);
      loading.value = false;
    };
    onMounted(() => {
      _getUserPageListByTenantId();
    });
    const roles = ref([]);
    const addRoleByTenant = async () => {
      const res = await getRoleList({
        tenantId
      });
      // formSchemasRef.value.find((item) => item.field === 'userRoleList').checkboxArr = res
      roles.value = res;
    };
    addRoleByTenant();
    const handleCurrentChange = e => {
      setCurrentPage(e);
      _getUserPageListByTenantId();
    };

    // 添加租户用户
    const tenantUserVisible = ref(false); // show or hide

    const currentTenantUser = ref(null);
    // const addUserHandler = () => {
    //   tenantUserVisible.value = true
    // }

    const handleUpdateUser = row => {
      tenantUserVisible.value = true;
      currentTenantUser.value = row;
    };
    const handleRefresh = async () => {
      setCurrentPage(1);
      keyword.value = '';
      tenantId.value = '';
      _getUserPageListByTenantId();
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
        class: "header",
        shadow: "never",
        style: {
          "border": "none"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createTextVNode(" 租户： "), _createVNode(_unref(TenantSelect), {
          modelValue: tenantId.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => tenantId.value = $event)
        }, null, 8, ["modelValue"]), _hoisted_3, _createTextVNode(" 用户名： "), _createVNode(_component_el_input, {
          style: {
            "width": "300px"
          },
          placeholder: "请输入用户名",
          modelValue: keyword.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => keyword.value = $event)
        }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
          type: "primary",
          icon: _unref(Search),
          onClick: _getUserPageListByTenantId
        }, {
          default: _withCtx(() => [_createTextVNode(" 查询 ")]),
          _: 1
        }, 8, ["icon"]), _createVNode(_component_el_button, {
          icon: _unref(Refresh),
          onClick: handleRefresh
        }, {
          default: _withCtx(() => [_createTextVNode(" 重置 ")]),
          _: 1
        }, 8, ["icon"])])])]),
        _: 1
      }), _createVNode(_component_el_card, {
        shadow: "never",
        style: {
          "border": "none"
        }
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
          border: true,
          data: tableData.value,
          style: {
            "width": "100%"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: "#",
            type: "index",
            index: index => _unref(indexMethod)(index, _unref(currentPage), _unref(pageSize)),
            "min-width": "20"
          }, null, 8, ["index"]), _createVNode(_component_el_table_column, {
            label: "账号",
            prop: "userName"
          }), _createVNode(_component_el_table_column, {
            label: "手机号",
            prop: "mobile"
          }), _createVNode(_component_el_table_column, {
            label: "创建时间",
            prop: "createTime"
          }), _createVNode(_component_el_table_column, {
            label: "操作"
          }, {
            default: _withCtx(({
              row
            }) => [_createVNode(_component_el_button, {
              onClick: $event => handleUpdateUser(row),
              type: "primary"
            }, {
              default: _withCtx(() => [_createTextVNode(" 修改 ")]),
              _: 2
            }, 1032, ["onClick"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])), [[_directive_loading, loading.value]]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_pagination, {
          class: "pagination",
          onCurrentChange: handleCurrentChange,
          "current-page": _unref(currentPage),
          "page-size": _unref(pageSize),
          total: _unref(total),
          layout: "total, prev, pager, next, jumper"
        }, null, 8, ["current-page", "page-size", "total"])])]),
        _: 1
      }), _createVNode(_unref(TenantUser), {
        modelValue: tenantUserVisible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => tenantUserVisible.value = $event),
        tenantId: tenantId.value,
        onClearModel: _cache[3] || (_cache[3] = $event => currentTenantUser.value.value = null),
        model: currentTenantUser.value,
        onRefreshData: _getUserPageListByTenantId,
        roles: roles.value,
        formSchemas: formSchemasRef.value
      }, null, 8, ["modelValue", "tenantId", "model", "roles", "formSchemas"])]);
    };
  }
};